<script>
    import Header from "./Header.svelte";
	import WidgetKeyword from "./WidgetKeyword.svelte";
	import WidgetGraph from "./WidgetGraph.svelte";
	import WidgetUser from "./WidgetUser.svelte";
	
</script>

<div class="h-screen flex flex-col font-sans">
	

	<main class="flex-grow w-full bg-slate-900 flex p-10">
		<WidgetGraph />
		<div class="flex flex-col w-1/6 flex-none">
			<Header />
			<WidgetKeyword />
			<WidgetUser />
		</div>
	</main>
</div>

